import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { Button } from "primereact/button";
import { isLoginAuth } from "utils/common";

class Unauthorized extends Component {
  goToDashboard = () => {
    if (isLoginAuth()) {
      this.props.history.push("/template/listing");
    }
  };

  render() {
    return (
      <div>
        <div className="unauthorized-page-access">Unauthorized Access!</div>
        <p className="unauthorized-page-message p-text-center p-m-2">
          You don&apos;t have access to the screen. Please contact administrator
          for more details.
        </p>
        <div className="p-field p-text-center p-mx-6 p-mb-6 p-mt-5">
          <Button
            label="Go To Dashboard"
            className="goto-home-button p-mt-2 p-mr-3"
            onClick={this.goToDashboard}
          />
        </div>
      </div>
    );
  }
}

export default withRouter(Unauthorized);
